import { render, staticRenderFns } from "./OldViewer.vue?vue&type=template&id=18ec2506&scoped=true"
import script from "./OldViewer.vue?vue&type=script&lang=js"
export * from "./OldViewer.vue?vue&type=script&lang=js"
import style0 from "./OldViewer.vue?vue&type=style&index=0&id=18ec2506&prod&lang=css"
import style1 from "./OldViewer.vue?vue&type=style&index=1&id=18ec2506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec2506",
  null
  
)

export default component.exports